import {Injectable} from '@angular/core';
import {ApiService} from '../../core/service/api.service';
import {Observable} from 'rxjs/Observable';
import {User} from '../model/user';

@Injectable()
export class UserService {

    constructor(private api: ApiService) {
    }

    findUserSources(criteria?: Object): Observable<User[]> {
        return this.api.get('user-sources', criteria)
            .map((row: Array<Object>) => {
                    return row.map(function (obj) {
                        const user = new User(obj);
                        return user;
                    })
                }
            );
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/user/services/user.service.ts